export default "__VITE_ASSET__5a30aa72__"